(function () {
  const block = {
    $blocks: document.querySelectorAll('.awards_and_accolades'),
    init() {
      if (this.$blocks.length) {

      }
    }
  };

  block.init();
})();

